import React, { useState } from "react";
import { Button, InputLabel, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { DialogWindow } from "UI/DialogWindow";
import { FormTextField } from "UI/FormTextField";
import { FormSelectField } from "UI/FormSelectField";
import { required } from "models/validations";
import { convertDeviceType } from "utils/helpers";
import { useCloseAndReset } from "hooks/useCloseAndReset";
// import { useAppDispatch } from "store/hooks";
// import { hideSpinner, showSpinner } from "store/reducers/spinnerReducer";
// import { API } from "aws-amplify";
// import { showError } from "store/reducers/errorReducer";
import { useScreenSize } from "hooks/useScreenSize";

const defaultFormData = {
  deviceType: "",
  iotDeviceId: "",
};

export const AddNewButtonDialog = ({
  open,
  handleClose,
  setButtonId,
  setButtonType,
}) => {
  // const dispatch = useAppDispatch();
  const [selectedType, setSelectedType] = useState("");

  const {
    control,
    handleSubmit,
    getValues,
    reset,
    setValue,
    formState: { isDirty },
  } = useForm({
    defaultValues: defaultFormData,
  });

  const onSubmit = async () => {
    const button = getValues();

    setButtonId(button?.iotDeviceId);
    setButtonType(button?.deviceType);
  };

  const closeAndReset = useCloseAndReset(() => {
    reset(defaultFormData);
    handleClose();
  }, isDirty);

  const handleChangeType = (e) => {
    const buttonType = e?.target?.value;
    if (!["Real", "Hard", "Physical"].includes(buttonType)) {
      setValue("iotDeviceId", "Virtual");
    } else {
      setValue("iotDeviceId", "");
    }
    setValue("deviceType", buttonType);
    setSelectedType(buttonType);
  };

  const { isMobileWidth } = useScreenSize();

  return (
    <DialogWindow
      open={open}
      withCloseButton
      handleClose={closeAndReset}
      title={"Select button type"}
      content={
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack gap={3} mt={isMobileWidth ? 10 : 1}>
            <Stack alignItems={"flex-start"} flex={1}>
              <InputLabel htmlFor="deviceType">Type</InputLabel>
              <FormSelectField
                id="deviceType"
                name="deviceType"
                control={control}
                options={{
                  Virtual: "Digital",
                  Real: "Physical",
                }}
                rules={{ required }}
                onChange={handleChangeType}
              />
            </Stack>
            {["Real", "Hard", "Physical"].includes(selectedType) && (
              <Stack alignItems={"flex-start"}>
                <InputLabel htmlFor="iotDeviceId">Device Id Code</InputLabel>
                <FormTextField
                  id="iotDeviceId"
                  name="iotDeviceId"
                  control={control}
                  rules={{ required }}
                  InputProps={{
                    autoComplete: "off",
                  }}
                />
              </Stack>
            )}
          </Stack>
        </form>
      }
      actions={
        <Stack alignItems={"center"} flex={1}>
          <Button variant="contained" onClick={handleSubmit(onSubmit)}>
            Add New {convertDeviceType(selectedType)} Button
          </Button>
        </Stack>
      }
    />
  );
};
